export const METHOD_LABEL = {
  cash: { id: 'Tunai', en: 'Cash' }, xendit: { id: 'Xendit (QRIS/VA/e-wallet)', en: 'Xendit (QRIS/VA/e-wallet)' }, manual: { id: 'Manual (lainnya)', en: 'Manual (other)' },
  card: { id: 'Kartu/EDC', en: 'Card/EDC' }, ewallet: { id: 'E-wallet', en: 'E-wallet' }, transfer: { id: 'Transfer bank', en: 'Bank transfer' }, split: { id: 'Kombinasi', en: 'Split' },
};
export const METHODS = ['cash', 'xendit', 'card', 'ewallet', 'transfer', 'manual'];
export const mlabel = (m, id) => (METHOD_LABEL[m]?.[id ? 'id' : 'en'] || m).split(' (')[0];
export const STATUS = {
  pending: { id: 'Belum dibayar', en: 'Pending', cls: 'bg-amber-50 text-amber-800 border-amber-200' },
  paid: { id: 'Lunas', en: 'Paid', cls: 'bg-emerald-50 text-emerald-800 border-emerald-200' },
  cancelled: { id: 'Dibatalkan', en: 'Cancelled', cls: 'bg-slate-100 text-slate-700 border-slate-200' },
};

export const linePrice = (i) => i.product.price + (i.variant?.price_extra || 0);
export const lineKey = (pid, vid) => `${pid}::${vid || ''}`;

/** Cart totals. items: [{product, variant?, qty, discount, note}] ; disc = transaction-level discount. */
export const cartTotals = (items, disc = 0) => {
  const gross = items.reduce((s, i) => s + linePrice(i) * i.qty, 0);
  const itemDisc = items.reduce((s, i) => s + (Number(i.discount) || 0), 0);
  const total = Math.max(0, gross - itemDisc - (Number(disc) || 0));
  return { gross, itemDisc, txDisc: Number(disc) || 0, discount: itemDisc + (Number(disc) || 0), total };
};

export const maxDisc = (base, pct) => (pct > 0 ? Math.round((base * pct) / 100) : base);

export const fmtDT = (iso) => (iso ? new Date(iso).toLocaleString('id-ID', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit', timeZone: 'Asia/Jakarta' }) : '—');
